import script from "./PopularQueriesContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopularQueriesContainer.vue?vue&type=script&lang=ts&setup=true"

import "./PopularQueriesContainer.vue?vue&type=style&index=0&id=1cc972a0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc972a0"]])

export default __exports__